import { combineReducers } from "redux";
import { authReducer } from "@/redux/reducers/auth.reducer";
import { forgotPasswordReducer } from "@/redux/reducers/forgot.password.reducer";

export default combineReducers({
	auth: authReducer,
	forgotPassword: forgotPasswordReducer,
});
